import React from 'react';
import NewsItem from '../newsItem/newsItem';
import './_latestNews.scss';

export default function latestNews ({ leftPadding, rightPadding, news, title }) {
  return (
    <section
      className={`latestNewsBlock
                         ${leftPadding ? 'leftPadding' : ''}
                         ${rightPadding ? 'rightPadding' : ''}`}
    >
      <div className='headBlock'>
        <h3>{title}</h3>
        {/* <a href='#'>See All</a> */}
      </div>
      <div className='newsList'>
        {news?.map((newsItem, i) => (
          <NewsItem
            key={newsItem.id}
            externalLink={newsItem.external_url}
            url={newsItem.url}
            date={newsItem.date}
            title={newsItem.title}
            desc={newsItem.subtitle}
            imageUrl={newsItem.poster}
          />
        ))}
      </div>
    </section>
  );
}
